import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FcuIDs } from '@helpers/ams-data-fram-constants';
import { FcuStatus, FuStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-fcu-status-indicator',
    templateUrl: './fcu-status-indicator.component.html',
    styleUrls: ['./fcu-status-indicator.component.scss'],
    standalone: false,
})
export class FcuStatusIndicatorComponent implements OnChanges {
    @Input() isReceivingData: boolean;
    @Input() fcuSrc: string;
    @Input() selectedFcu: FcuStatus;
    @Input() selectedFu: FuStatus;
    @Output() onGoBack: EventEmitter<void> = new EventEmitter<void>();

    selectedFuIndex: number;
    fcuIndex: number;

    constructor(private systemStatusService: SystemStatusService) {}

    ngOnInit(): void {
        if (this.fcuSrc) {
            this.fcuIndex = FcuIDs[this.fcuSrc];
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fcuSrc && this.fcuSrc) {
            this.fcuIndex = FcuIDs[this.fcuSrc];
        }
        if (this.fcuIndex && this.selectedFu && changes.selectedFu) {
            this.selectedFuIndex = this.selectedFcu?.fu.indexOf(this.selectedFu);
            this.selectedFu = this.selectedFcu?.fu[this.selectedFuIndex];
        }
    }

    hasAlarms(key): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.selectedFcu[key]) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }

    handleSelectFu(fuStatus): void {
        this.selectedFuIndex = this.selectedFcu?.fu.indexOf(fuStatus);
        this.selectedFu = fuStatus;
    }

    unselectFu() {
        this.selectedFuIndex = null;
        this.selectedFu = null;
    }

    unselectFcu() {
        this.selectedFuIndex = null;
        this.selectedFu = null;
        this.selectedFcu = null;
        this.onGoBack.emit();
    }
}
